export const MESSENGER_URL = "https://m.me/558751367325531";

export const AIRBNB_INTRO = {
  title: "Xander's Staycations (1–30)",
  subtitle: "Near SM MOA Pasay & SM Southmall, Las Piñas",
  description: "Enjoy comfortable, cozy, fully furnished Airbnb units with Pool View Balconies — perfect for staycations, business trips, and short getaways.",
  offers: [
    "1-Bedroom & 2-Bedroom units",
    "Pool-view balconies",
    "Clean & fully furnished",
    "Ideal for couples, families & barkada",
    "Legit Airbnb Superhost",
  ],
  locations: [
    "SM MOA Area — Shell, Shore 1 & Shore 2 Residences",
    "SM Southmall — Las Piñas",
  ],
};

export const AIRBNB_LISTINGS = [
  { n: 1, name: "South T1", floor: "9th Floor", type: "1BR", view: "Pool-View Balcony", url: "https://airbnb.com/h/xanders-staycation-1-903" },
  { n: 2, name: "Shell-D", floor: "9th Floor", type: "1BR", view: "Pool-View Balcony", url: "https://airbnb.com/h/xanders-staycation-2-936" },
  { n: 3, name: "Shell-B", floor: "14th Floor", type: "1BR", view: "Pool-View Balcony", url: "https://airbnb.com/h/xanders-staycation-3-1435" },
  { n: 4, name: "Shore-C2", floor: "18th Floor", type: "1BR", view: "Pool-View Balcony", url: "https://airbnb.com/h/xanders-staycation-4-1895" },
  { n: 5, name: "South-T1", floor: "11th Floor", type: "2BR", view: "Pool-View Balcony", url: "https://airbnb.com/h/xanders-staycation-5-1140-2br", altUrl: "https://airbnb.com/h/xanders-staycation-5-1140-1br", altLabel: "1BR variant" },
  { n: 6, name: "Shell-D", floor: "4th Floor", type: "1BR", view: "Pool-View Balcony", url: "https://airbnb.com/h/xanders-staycation-6-436" },
  { n: 7, name: "Shore-A", floor: "4th Floor", type: "1BR", view: "Pool-View Balcony", url: "https://airbnb.com/h/xanders-staycation-7-430" },
  { n: 8, name: "Shore 2-T1", floor: "4th Floor", type: "1BR", view: "Pool-View Balcony", url: "https://airbnb.com/h/xanders-staycation-8-475" },
  { n: 9, name: "Shell-B", floor: "16th Floor", type: "1BR", view: "Pool-View Balcony", url: "https://airbnb.com/h/xanders-staycation-9-1646" },
  { n: 10, name: "Shore-C2", floor: "16th Floor", type: "1BR", view: "Pool-View Balcony", url: "https://airbnb.com/h/xanders-staycation-10-1692" },
  { n: 11, name: "Shore-C2", floor: "18th Floor", type: "1BR", view: "Pool-View Balcony", url: "https://airbnb.com/h/xanders-staycation-11-1899" },
  { n: 12, name: "Shore-C2", floor: "14th Floor", type: "1BR", view: "Pool-View Balcony", url: "https://airbnb.com/h/xanders-staycation-12-1494" },
  { n: 13, name: "Shore-D", floor: "15th Floor", type: "1BR", view: "Pool-View Balcony", url: "https://airbnb.com/h/xanders-staycation-13-1509" },
  { n: 14, name: "Shore-A", floor: "15th Floor", type: "1BR", view: "Pool-View Balcony", url: "https://airbnb.com/h/xanders-staycation-14-1516" },
  { n: 15, name: "Shell-B", floor: "8th Floor", type: "1BR", view: "Pool-View Balcony", url: "https://airbnb.com/h/xanders-staycation-15-839" },
  { n: 16, name: "Shore 2-T2", floor: "11th Floor", type: "1BR", view: "Pool-View Balcony", url: "https://airbnb.com/h/xanders-staycation-16-11111" },
  { n: 17, name: "Shore 2-T1", floor: "4th Floor", type: "1BR", view: "Pool-View Balcony", url: "https://airbnb.com/h/xanders-staycation-17-448" },
  { n: 18, name: "Shell-A", floor: "6th Floor", type: "1BR", view: "Pool-View Balcony", url: "https://airbnb.com/h/xanders-staycation-18-626" },
  { n: 19, name: "Shell-B", floor: "11th Floor", type: "1BR", view: "Pool-View Balcony", url: "https://airbnb.com/h/xanders-staycation-19-1129" },
  { n: 20, name: "Shore 2-T2", floor: "15th Floor", type: "1BR", view: "Pool-View Balcony", url: "https://airbnb.com/h/xanders-staycation-20-1550" },
  { n: 21, name: "Shell-A", floor: "9th Floor", type: "1BR", view: "MOA-Facing Balcony", url: "https://airbnb.com/h/xanders-staycation-21-954" },
  { n: 22, name: "Shore-C2", floor: "18th Floor", type: "1BR", view: "Pool-View Balcony", url: "https://airbnb.com/h/xanders-staycation-22-1897" },
  { n: 23, name: "Shore-D", floor: "15th Floor", type: "1BR", view: "Pool-View Balcony", url: "https://airbnb.com/h/xanders-staycation-23-1508" },
  { n: 24, name: "Shore 2-T2", floor: "15th Floor", type: "1BR", view: "Pool-View Balcony", url: "https://airbnb.com/h/xanders-staycation-24-1561" },
  { n: 25, name: "Shore 2-T2", floor: "10th Floor", type: "2BR", view: "Pool-View Balcony", url: "https://airbnb.com/h/xanders-staycation-25-1059" },
  { n: 26, name: "South T1", floor: "15th Floor", type: "1BR", view: "City-View Balcony", url: "https://airbnb.com/h/xanders-staycation-26-1526" },
  { n: 27, name: "Shore-A", floor: "16th Floor", type: "1BR", view: "Pool-View Balcony", url: "https://airbnb.com/h/xanders-staycation-27-1620" },
  { n: 28, name: "Shore-D", floor: "4th Floor", type: "1BR", view: "Pool-View Balcony", url: "https://airbnb.com/h/xanders-staycation-28-418" },
  { n: 29, name: "Shore-C1", floor: "4th Floor", type: "1BR", view: "Pool-View Balcony", url: "https://airbnb.com/h/xanders-staycation-29-421" },
  { n: 30, name: "Shell-B", floor: "6th Floor", type: "2BR", view: "Pool-View Balcony", url: "https://airbnb.com/h/xanders-staycation-30-646-2br" },
];

export const ADMIN_CONTACTS = [
  { name: "Alex", role: "Admin", phone: "+63 995 377 8114", note: "Text only", actions: ["sms"] },
  { name: "Yvet", role: "Admin", phone: "+63 966 157 3678", note: "Call & text", actions: ["call", "sms"] },
  { name: "Rhoda", role: "Admin", phone: "+63 947 948 851", note: "Call & text", actions: ["call", "sms"] },
  { name: "Daphne", role: "Admin", phone: "+63 994 698 2206", note: "Call & text", actions: ["call", "sms"] },
];

export const CARETAKER_CONTACTS = [
  { name: "Joney", area: "Shell A, B, C, D", phone: "+63 930 694 7057" },
  { name: "Jeny", area: "Shore C1, C2 & Shell", phone: "+63 945 134 0995" },
  { name: "Ken", area: "Shore A & D", phone: "+63 945 678 6753" },
  { name: "Sky", area: "Shore 2 T1 & T2", phone: "+63 977 023 8545" },
];

export const CONTACT = {
  phone: "+63 995 377 8114",
  email: "xanderstaycation2026@gmail.com",
  facebook: "https://facebook.com/xandersstaycation",
  messenger: MESSENGER_URL,
  address: "Pasay City & Las Piñas City, Metro Manila, Philippines",
};

export const LOCATIONS = [
  {
    key: "shell-residences",
    name: "Shell Residences",
    area: "Pasay City",
    near: "Near SM Mall of Asia",
    tagline: "Bayside living, minutes from the SMX, Esplanade and MOA Arena.",
    image: "https://customer-assets.emergentagent.com/job_affordable-staycay/artifacts/snsx408u_Shell.avif",
  },
  {
    key: "shore-1",
    name: "Shore 1 Residences",
    area: "Pasay City",
    near: "Near SM Mall of Asia",
    tagline: "Resort-style amenities steps away from the MOA Complex.",
    image: "https://customer-assets.emergentagent.com/job_affordable-staycay/artifacts/fpwpgqaw_Shore%201.avif",
  },
  {
    key: "shore-2",
    name: "Shore 2 Residences",
    area: "Pasay City",
    near: "Near SM Mall of Asia",
    tagline: "Pool deck views and a quick stroll to MOA Bay.",
    image: "https://customer-assets.emergentagent.com/job_affordable-staycay/artifacts/vqmykn2y_Shore%202.jpeg",
  },
  {
    key: "south-residences",
    name: "South Residences",
    area: "Las Piñas City",
    near: "Near SM Southmall",
    tagline: "Quiet south-side comfort right beside SM Southmall.",
    image: "https://customer-assets.emergentagent.com/job_affordable-staycay/artifacts/74hgj8o1_south.avif",
  },
];

export const GALLERY_IMAGES = [
  { src: "https://customer-assets.emergentagent.com/job_affordable-staycay/artifacts/bexix2mq_1895.jpg", alt: "Shore 1895 — cozy living room with balcony view", span: "md:col-span-2" },
  { src: "https://customer-assets.emergentagent.com/job_affordable-staycay/artifacts/qdxtfndw_1897.jpg", alt: "Shore 1897 — bedroom and resort pool view" },
  { src: "https://customer-assets.emergentagent.com/job_affordable-staycay/artifacts/euuldt09_1899.jpg", alt: "Shore 1899 — comfy bedroom with bayside view" },
  { src: "https://customer-assets.emergentagent.com/job_affordable-staycay/artifacts/crq29d1w_1692.jpg", alt: "Shore 1692 — bright bedroom and kitchen view" },
  { src: "https://customer-assets.emergentagent.com/job_affordable-staycay/artifacts/jqk8keqv_1494.jpg", alt: "Shore 1494 — living room, dining and pool view" },
  { src: "https://customer-assets.emergentagent.com/job_affordable-staycay/artifacts/8xilflzx_421.jpg", alt: "Shore 421 — pool view and cozy living space" },
  { src: "https://customer-assets.emergentagent.com/job_affordable-staycay/artifacts/6dza6zoh_436.jpg", alt: "Shell 436 — bedroom and dining area" },
  { src: "https://customer-assets.emergentagent.com/job_affordable-staycay/artifacts/1dww6vw5_936.jpg", alt: "Shell 936 — resort pool views and interiors" },
  { src: "https://customer-assets.emergentagent.com/job_affordable-staycay/artifacts/eqcwdpzz_646.jpg", alt: "Shell 646 — 2BR with kitchen and bedroom views" },
  { src: "https://customer-assets.emergentagent.com/job_affordable-staycay/artifacts/iirtgax5_1435.jpg", alt: "Shell 1435 — high-floor views and cozy interiors" },
  { src: "https://customer-assets.emergentagent.com/job_affordable-staycay/artifacts/yxri4hln_1646.jpg", alt: "Shell 1646 — resort pool views and dining" },
  { src: "https://customer-assets.emergentagent.com/job_affordable-staycay/artifacts/8l3vp0c7_839.jpg", alt: "Shell 839 — Xanders Staycation 15 near SM MoA" },
  { src: "https://customer-assets.emergentagent.com/job_affordable-staycay/artifacts/4a5t18ta_1129.jpg", alt: "Shell 1129 — Xanders Staycation 19 near SM MoA" },
  { src: "https://customer-assets.emergentagent.com/job_affordable-staycay/artifacts/dfjlqa3s_626.jpg", alt: "Shell 626 — Xanders Staycation 18 near SM MoA" },
  { src: "https://customer-assets.emergentagent.com/job_affordable-staycay/artifacts/m3qnxplz_954.jpg", alt: "Shell 954 — Xanders Staycation 21 facing SM MoA" },
  { src: "https://customer-assets.emergentagent.com/job_affordable-staycay/artifacts/tmz556a5_1620.jpg", alt: "Shore 1620 — Xanders Staycation 27 near SM MoA" },
  { src: "https://customer-assets.emergentagent.com/job_affordable-staycay/artifacts/lh413sap_430.jpg", alt: "Shore 430 — Xanders Staycation 7 near SM MoA" },
  { src: "https://customer-assets.emergentagent.com/job_affordable-staycay/artifacts/p9bqyk0e_1516.jpg", alt: "Shore 1516 — Xanders Staycation 14 near SM MoA" },
  { src: "https://customer-assets.emergentagent.com/job_affordable-staycay/artifacts/t3whgvw3_448.jpg", alt: "Shore2 448 — Xanders Staycation 17 near SM MoA" },
  { src: "https://customer-assets.emergentagent.com/job_affordable-staycay/artifacts/0azkrq5h_475.jpg", alt: "Shore2 475 — Xanders Staycation 8 near SM MoA" },
  { src: "https://customer-assets.emergentagent.com/job_affordable-staycay/artifacts/1rylcn2y_903.jpg", alt: "South 903 — Xanders Staycation 1 at SM Southmall" },
  { src: "https://customer-assets.emergentagent.com/job_affordable-staycay/artifacts/h8w4ref2_1140%202BR.jpg", alt: "South 1140 (2BR) — Xanders Staycation 5 at SM Southmall" },
  { src: "https://customer-assets.emergentagent.com/job_affordable-staycay/artifacts/75y122hv_1140_1BR.jpg", alt: "South 1140 (1BR) — Xanders Staycation 5 at SM Southmall" },
  { src: "https://customer-assets.emergentagent.com/job_affordable-staycay/artifacts/q1g2vuwr_1526.jpg", alt: "South 1526 — Xanders Staycation 26 at South Residences T1" },
  { src: "https://customer-assets.emergentagent.com/job_affordable-staycay/artifacts/wmys16u9_418.jpg", alt: "Shore 418 — Xanders Staycation 28, MoA's best offer" },
  { src: "https://customer-assets.emergentagent.com/job_affordable-staycay/artifacts/4cunqmwl_1508.jpg", alt: "Shore 1508 — Xanders Staycation 23, MoA best offer (2p)" },
  { src: "https://customer-assets.emergentagent.com/job_affordable-staycay/artifacts/5ia2mf7e_1509.jpg", alt: "Shore 1509 — Xanders Staycation 13, MoA best offer (2p)" },
  { src: "https://customer-assets.emergentagent.com/job_affordable-staycay/artifacts/4f7lahtd_11-111.jpg", alt: "Shore 2 11-111 — Xanders Staycation 16 in SM MoA (2p)" },
  { src: "https://customer-assets.emergentagent.com/job_affordable-staycay/artifacts/ine7adc2_1059.jpg", alt: "Shore 2 1059-T2 — Xanders Staycation 25, 2BR Pool View", span: "md:col-span-2" },
  { src: "https://customer-assets.emergentagent.com/job_affordable-staycay/artifacts/us9r419h_1550.jpg", alt: "Shore 2 1550 — Xanders Staycation 20, MoA's best offer" },
  { src: "https://customer-assets.emergentagent.com/job_affordable-staycay/artifacts/53pzjmnq_1561.jpg", alt: "Shore 2 1561-T2 — Xanders Staycation 24, 1BR Pool View" },
];

export const RATE_TIERS = [
  {
    name: "1-Bedroom Unit (2 pax)",
    nightly: 1750,
    description: "Perfect for solo travelers or couples. Comfortably fits 2 guests.",
    includes: [
      "Free Wi-Fi",
      "Netflix TV",
      "Air-conditioned",
      "Hot & cold shower with bidet",
      "Queen size bed",
      "Sofa bed",
      "Refrigerator",
      "Kitchen utensils",
      "Automatic washing machine",
      "Towels provided",
      "Guest kit (shampoo, soap, toothbrush & toothpaste)",
    ],
    locations: "Available across all properties",
    badge: "Starter",
  },
  {
    name: "1-Bedroom Unit (4 pax)",
    nightly: 2250,
    description: "Roomy comfort for couples and small families. Up to 4 guests.",
    includes: [
      "Free Wi-Fi",
      "Netflix TV",
      "Air-conditioned",
      "Hot & cold shower with bidet",
      "Queen size bed + sofa bed",
      "Refrigerator",
      "Kitchen utensils",
      "Automatic washing machine",
      "Towels provided",
      "Guest kit (shampoo, soap, toothbrush & toothpaste)",
    ],
    locations: "Available at Shell, Shore 1 & Shore 2",
    badge: "Family favorite",
  },
  {
    name: "2-Bedroom Unit (4 pax)",
    nightly: 2500,
    description: "More space, more privacy. Ideal for two couples or a small family of 4.",
    includes: [
      "Free Wi-Fi",
      "Netflix TV",
      "Air-conditioned",
      "Hot & cold shower with bidet",
      "Queen size bed + sofa bed",
      "Refrigerator",
      "Kitchen utensils",
      "Automatic washing machine",
      "Towels provided",
      "Guest kit (shampoo, soap, toothbrush & toothpaste)",
    ],
    locations: "Available at Shell & Shore 1",
    badge: "More space",
  },
  {
    name: "2-Bedroom Unit (6 pax)",
    nightly: 3500,
    description: "Best for barkadas and bigger families. Comfortably fits up to 6 guests.",
    includes: [
      "Free Wi-Fi",
      "Netflix TV",
      "Air-conditioned",
      "Hot & cold shower with bidet",
      "Queen size bed + sofa bed",
      "Refrigerator",
      "Kitchen utensils",
      "Automatic washing machine",
      "Towels provided",
      "Guest kit (shampoo, soap, toothbrush & toothpaste)",
    ],
    locations: "Available at Shell & Shore 1",
    badge: "Best for groups",
  },
];

export const RATE_ADD_ONS = [
  {
    name: "Pool access",
    price: "+ ₱150 / pax",
    note: "Add it on for any guest who wants to use the swimming pool & deck amenities.",
  },
  {
    name: "Parking (subject to availability)",
    price: "+ ₱700 / night",
    note: "Pay-parking lots are available right outside the condo. Reserved basement parking is ₱700/night when available.",
  },
  {
    name: "Guest & Baggage Assistance",
    price: "+ ₱200",
    note: "Need a hand checking in or hauling bags up to your unit? Our friendly assistant has you covered.",
  },
  {
    name: "Early check-in / Late check-out",
    price: "+ ₱1,000",
    note: "Subject to availability. Reach out via Messenger and we'll do our best to make it happen.",
  },
];

export const LONG_STAY_DISCOUNTS = [
  { range: "3 – 6 nights", percent: 5, label: "Short break", note: "Perfect for a long weekend." },
  { range: "1 – 3 weeks", percent: 10, label: "Extended stay", note: "Great for remote work or visiting family." },
  { range: "4 weeks & longer", percent: 15, label: "Monthly stay", note: "Our best value — message us for monthly availability." },
];
